import {
    Typography,
    Row,
    Col,
    Card,
    Divider,
   Timeline
} from 'antd';
import {CheckCircleFilled, ExclamationCircleFilled, RedoOutlined} from "@ant-design/icons";
import Meta from "antd/es/card/Meta";
import Terminal from "./Terminal";
import React, { useEffect, useState } from "react"
import { useAuth0 } from '@auth0/auth0-react';
import { useParams } from 'react-router-dom';
import fetchApi from "../helper/fetchApi";
import useInterval from "../helper/useInterval";

export default function JobDetail() {
    let { jobId } = useParams()
    const { getAccessTokenSilently } = useAuth0();
    const [data, setData] = useState([])
    const [logs, setLogs] = useState([])
    //const [loading, setLoading] = useState(true)

    useEffect((data) => {
        (async () => {
            let data = await fetchApi('imports/get/'+jobId, getAccessTokenSilently);
            if(data !== null) {
                setData(data);
            }
            let logs = await fetchApi('imports/getLogs/'+jobId, getAccessTokenSilently);
            if(logs !== null) {
                setLogs(logs);
            }
        })()
    }, [])

    useInterval(() => {
        (async () => {
            let data = await fetchApi('imports/get/'+jobId, getAccessTokenSilently);
            if(data !== null) {
                setData(data);
            }
            let logs = await fetchApi('imports/getLogs/'+jobId, getAccessTokenSilently);
            if(logs !== null) {
                setLogs(logs);
            }
        })()
    },7500);

    let active = 0;
    switch(data.state) {
        case 'PREPARATION':
            active = 1;
            break;
        case 'TRANSFORMATION':
            active = 2;
            break;
        case 'IMPORT':
            active = 3;
            break;
        case 'SUCCESSFUL':
            active = 4;
            break;
        case 'FAILED':
            active = 5;
            break;
    }
    const timeline = [
        {
            children: 'Pending - waiting to be processed',
            color: 'gray',
            ...(active == 0 && {
                dot: <RedoOutlined spin />,
                color: 'green',
                }),
            ...(active > 0 && {
                    color: 'blue'
            }),
        },
        {
            children: 'Preparation - preparing the import',
            color: 'gray',
            ...(active == 1 && {
                dot: <RedoOutlined spin />,
                color: 'green',
            }),
            ...(active > 1 && {
                color: 'blue'
            }),
        },
        {
            children: 'Transformation -  transforming the data for the import',
            color: 'gray',
            ...(active == 2 && {
                dot: <RedoOutlined spin />,
                color: 'green',
            }),
            ...(active > 2 && {
                color: 'blue'
            }),
        },
        {
            children: 'Import - importing the data to Shopware',
            color: 'gray',
            ...(active == 3 && {
                dot: <RedoOutlined spin />,
                color: 'green',
            }),
            ...(active > 3 && {
                color: 'blue'
            }),
        },
        {
            children: 'Finished - import finished',
            color: 'gray',
            ...(active == 4 && {
                dot: <CheckCircleFilled />,
                color: 'green',
            }),
            ...(active > 4 && {
                dot: <ExclamationCircleFilled />,
                color: 'red'
            }),
        },
    ]

    return (
        <Card
            title={'Job: '+data.name}
            extra={<Typography><Typography.Text type={'secondary'}>Job ID: {data.id}</Typography.Text></Typography>}
        >
            <Row gutter={16}>
                <Col className="gutter-row" span={6}>
                    <Meta title="File name" description={data.file}/>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Meta title="Initiator" description={data.initiator} />
                </Col>
                <Col className="gutter-row" span={6}>
                    <Meta title="Created" description={new Date(data.created).toLocaleDateString("en-US") + " " +new Date(data.created).toLocaleTimeString("en-US")} />
                </Col>
                <Col className="gutter-row" span={6}>
                    <Meta title="Last update" description={new Date(data.updated).toLocaleDateString("en-US") + " " +new Date(data.updated).toLocaleTimeString("en-US")} />
                </Col>
            </Row>
            <Divider />
            <Timeline
                items={timeline}
            />
            <Terminal logs={logs} />

        </Card>
    );
}